import { render, staticRenderFns } from "./handleHywj.vue?vue&type=template&id=130ed926&"
import script from "./handleHywj.vue?vue&type=script&lang=js&"
export * from "./handleHywj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports